import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class IndexRoute extends Route {
	@service('billing') declare billingService: Service.Billing;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(transition: PublicTransition): Promise<unknown> | void {
		// Error and not-found fallbacks land on index; inside the native app Home lives under /m.
		if (this.navigationService.isMobileApp) {
			const theme = transition.to?.queryParams.theme;

			this.navigationService.replaceRoute('mobile.home', {
				queryParams: theme ? { theme } : {},
			});
			return;
		}

		// Home is hidden in the nav for this user, so Databoards is their landing page. The agency
		// blocker only allows index, so a breached agency stays here for its popup.
		if (
			this.currentUserService.isAgencyUserInClientSpace &&
			!this.billingService.agencyClientPackDowngradeLimitsBreached
		) {
			this.navigationService.replaceRoute('boards');
			return;
		}

		document.body.id = 'page-home';

		// Home loads its own data through the BFF, so only the boot requests are awaited here.
		return this.navigationService.initialRequestsPromise;
	}
}
